/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiUTMEntityLevelFromJSON, ApiUTMEntityLevelToJSON, } from './ApiUTMEntityLevel';
export function InlineObject10FromJSON(json) {
    return InlineObject10FromJSONTyped(json, false);
}
export function InlineObject10FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'classificationItemIds': !exists(json, 'classificationItemIds') ? undefined : json['classificationItemIds'],
        'entityId': !exists(json, 'entityId') ? undefined : json['entityId'],
        'landingPathId': !exists(json, 'landingPathId') ? undefined : json['landingPathId'],
        'level': !exists(json, 'level') ? undefined : ApiUTMEntityLevelFromJSON(json['level']),
        'rezonateUrl': !exists(json, 'rezonateUrl') ? undefined : json['rezonateUrl'],
        'splitCampaignId': !exists(json, 'splitCampaignId') ? undefined : json['splitCampaignId'],
    };
}
export function InlineObject10ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'classificationItemIds': value.classificationItemIds,
        'entityId': value.entityId,
        'landingPathId': value.landingPathId,
        'level': ApiUTMEntityLevelToJSON(value.level),
        'rezonateUrl': value.rezonateUrl,
        'splitCampaignId': value.splitCampaignId,
    };
}
